<template>
    <div>
        <img src="/static/images/logo.svg" alt="Mijn Markt Logo" class="logo"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vMediaQuery from 'v-media-query';

    import firebase from 'firebase';

    @Component({
    })
    export default class Logo extends Vue {
        name = 'logo-menu';

        showMobileMenu = true;

        logout() {
            firebase.auth().signOut().then(() => {
                this.$router.go({name: 'signin'});
            })
        }

        toggleMobileMenu() {

        }
    }

    Vue.component('logo-menu', Logo);
</script>

<style src="./styles.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/general/menu/Logo.vue